import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Err from "../../../../routes/error";
import { normalize } from "normalizr";
import { predefinedTemplatesSchema, userTemplatesSchema } from "./templates-schema";
import { getUserTemplate, updateTemplate, sendTestEmail, createTemplate, getTemplates, deleteTemplate } from "../../api/templates-api";
import { SET_CURRENT_TEMPLATE, SET_TEMPLATES, SET_PREDEFINED_TEMPLATES, REMOVE_TEMPLATE } from "./templates-mutations";
import Amplitude from "@Shared/@Utils/amplitude";
export const LOAD_MARKETING_TEMPLATE = "LOAD_MARKETING_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const SEND_TEST_EMAIL = "SEND_TEST_EMAIL";
export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const UPDATE_CURRENT_TEMPLATE = "UPDATE_CURRENT_TEMPLATE";
export const LOAD_TEMPLATES = "LOAD_TEMPLATES";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
const actions = {
  [LOAD_MARKETING_TEMPLATE]: async (context, templateId) => {
    try {
      const template = await getUserTemplate(templateId);
      context.commit(SET_CURRENT_TEMPLATE, _objectSpread(_objectSpread({}, template), {}, {
        templateId
      }));
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_CURRENT_TEMPLATE]: async (context, data) => {
    context.commit(SET_CURRENT_TEMPLATE, data);
  },
  [UPDATE_TEMPLATE]: async (context, {
    templateId,
    data
  }) => {
    try {
      await updateTemplate(templateId, data);
      Amplitude.logEvent("Templates - template updated", {
        templateId
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [SEND_TEST_EMAIL]: async (context, {
    templateId,
    data
  }) => {
    try {
      await sendTestEmail(templateId, data);
      Amplitude.logEvent("Templates - email test sent", {
        templateId
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [CREATE_TEMPLATE]: async (context, data) => {
    try {
      const {
        templateId
      } = await createTemplate(data);
      Amplitude.logEvent("Templates - template created", {
        templateId
      });
      return templateId;
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_TEMPLATES]: async context => {
    try {
      var _userCreatedNormalize, _predefinedTemplatesN;
      const {
        predefinedTemplates,
        userCreated
      } = await getTemplates();
      const userCreatedNormalize = normalize(userCreated, [userTemplatesSchema]);
      context.commit(SET_TEMPLATES, {
        byId: ((_userCreatedNormalize = userCreatedNormalize.entities) == null ? void 0 : _userCreatedNormalize.templates) || {},
        allIds: userCreatedNormalize.result
      });
      const predefinedTemplatesNormalize = normalize(predefinedTemplates, [predefinedTemplatesSchema]);
      context.commit(SET_PREDEFINED_TEMPLATES, {
        byId: ((_predefinedTemplatesN = predefinedTemplatesNormalize.entities) == null ? void 0 : _predefinedTemplatesN.templates) || {},
        allIds: predefinedTemplatesNormalize.result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_TEMPLATE]: async (context, templateId) => {
    try {
      context.commit(REMOVE_TEMPLATE, templateId);
      await deleteTemplate(templateId);
      Amplitude.logEvent("Templates - template deleted", {
        templateId
      });
    } catch (e) {
      Err.handle(e);
      context.dispatch(LOAD_TEMPLATES);
    }
  }
};
export default actions;